import { useState } from 'react';

export const useFileManager = () => {
    const [uploadedFiles, setUploadedFiles] = useState([]);

    const handleFileUpload = (files) => {
        if (!files || files.length === 0) return;

        const fileArray = Array.from(files);
        const newFiles = fileArray.map(file => {
            if (file.size > 20 * 1024 * 1024) {
                alert(`File ${file.name} exceeds 20MB limit.`);
                return null;
            }
            return {
                id: Date.now() + Math.random(),
                name: file.name,
                type: file.type,
                preview: file.type.startsWith('image/') ? URL.createObjectURL(file) : null,
                data: file
            };
        }).filter(Boolean);

        setUploadedFiles(prev => [...prev, ...newFiles]);
    };

    const removeFile = (fileId) => {
        setUploadedFiles(prev => {
            const fileToRemove = prev.find(file => file.id === fileId);
            // Clean up preview URL if it exists
            if (fileToRemove?.preview) {
                URL.revokeObjectURL(fileToRemove.preview);
            }
            return prev.filter(file => file.id !== fileId);
        });
    };

    const clearFiles = () => {
        // Clean up all preview URLs
        uploadedFiles.forEach(file => {
            if (file.preview) {
                URL.revokeObjectURL(file.preview);
            }
        });
        setUploadedFiles([]);
    };

    const validateFile = (file) => {
        const maxSize = 20 * 1024 * 1024; // 20MB
        const allowedTypes = [
            'image/', 'audio/', 'video/', 'application/pdf',
            'text/csv', 'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-powerpoint',
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'text/plain'
        ];

        if (file.size > maxSize) {
            return { valid: false, error: `File ${file.name} exceeds 20MB limit.` };
        }

        const isAllowedType = allowedTypes.some(type => file.type.startsWith(type) || file.type === type);
        if (!isAllowedType) {
            return { valid: false, error: `File type ${file.type} is not supported.` };
        }

        return { valid: true };
    };

    const getFileIcon = (fileType) => {
        if (fileType.startsWith('image/')) return 'image';
        if (fileType.startsWith('audio/')) return 'audio';
        if (fileType.startsWith('video/')) return 'video';
        if (fileType === 'application/pdf') return 'pdf';
        if (fileType.includes('excel') || fileType.includes('spreadsheet')) return 'excel';
        if (fileType.includes('word') || fileType.includes('document')) return 'word';
        if (fileType.includes('powerpoint') || fileType.includes('presentation')) return 'powerpoint';
        return 'file';
    };

    return {
        uploadedFiles,
        handleFileUpload,
        removeFile,
        clearFiles,
        validateFile,
        getFileIcon
    };
};